// MarkdownRenderer.js
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownRenderer = ({ markdown, link }) => {
  const [file, setFile] = useState(markdown)
  useEffect(() => {
    if (link) {
      fetch(link)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then(text => setFile(text))
        .catch(error => console.error('Error fetching markdown file:', error));
    }
  }, [link]);
  const markdownStyles = {
    ul: {
      listStyleType: 'disc',
      marginLeft: '20px',
    },
    ol: {
      listStyleType: 'decimal',
      marginLeft: '20px',
    },
    li: {
      marginBottom: '5px',
    },
  };

  return (
    <div style={{ ...markdownStyles }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
        ul: ({ node, ...props }) => <ul style={markdownStyles.ul} {...props} />,
        ol: ({ node, ...props }) => <ol style={markdownStyles.ol} {...props} />,
        li: ({ node, ...props }) => <li style={markdownStyles.li} {...props} />,
      }}>
        {file}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
